import { EventEmitter, Output, Directive } from "@angular/core";

@Directive()
export class SidePanelBase {
	protected _componentData: any;

	public get componentData(): any {
		return this._componentData;
	}
	public set componentData(value: any) {
		this._componentData = value;
	}
    @Output() saveMethod: EventEmitter<any> = new EventEmitter<any>();
    protected editorKey: string;
    constructor() {
        let conf = window["PdfConfig"] as any;
        this.editorKey = (conf != null) ? conf.editorLicenseKey : "";
    }
}